import { motion } from 'framer-motion';
import Button from '../common/Button';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const { t } = useTranslation();
  const { lng } = useParams();
  const navigate = useNavigate();
  const bg = `url(${process.env.PUBLIC_URL}/assets/images/movinghero.jpg)`;
  return (
    <section className="hero-section" style={{ position:'relative', display: 'grid', placeItems: 'center', minHeight: '70vh', background:`${bg} center/cover no-repeat` }}>
      <div style={{ position:'absolute', inset:0, background:'linear-gradient(180deg, rgba(0,0,0,.2), rgba(0,0,0,.45))' }} />
  <motion.div className="hero-content" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} style={{ position:'relative', color:'#fff', padding: 24, textAlign:'center' }}>
        <h1 style={{ fontSize:'clamp(28px,6vw,56px)', marginBottom:12 }}>{t('hero.title')}</h1>
        <p style={{ maxWidth:720, margin:'0 auto 16px' }}>Profesionalne selidbe, pakovanje i skladištenje — brzo i bez stresa.</p>
        <Button onClick={() => navigate(`/${lng}/quote`)}>{t('hero.cta')}</Button>
      </motion.div>
      <style>{`
        @media (max-height: 400px){
          .hero-section{ min-height: 60vh; }
          .hero-section .hero-content{ padding-top: 8px !important; padding-bottom: 8px !important; }
        }
      `}</style>
    </section>
  );
}
